import { render, staticRenderFns } from "./OldMemberPage.vue?vue&type=template&id=032c9c62&scoped=true&"
import script from "./OldMemberPage.vue?vue&type=script&lang=js&"
export * from "./OldMemberPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032c9c62",
  null
  
)

export default component.exports